import gql from 'graphql-tag';

export const queryForCommercialContacts = gql`
  query queryForCommercialContacts(
    $limit: Int!
    $page: Int!
    $query: CommercialContactSortOrQueryInput
    $sort: CommercialContactSortOrQueryInput
  ) {
    queryForCommercialContacts(
      limit: $limit
      page: $page
      query: $query
      sort: $sort
    ) {
      items {
        id
        firstName
        lastName
        companyId
        jobRoleId
        deskPhone
        mobilePhone
        emailAddress
        ice
        createdAt
        createdBy
        updatedAt
        updater
        version
        Company {
          id
          name
          abbreviation
          version
        }
        JobRole {
          id
          name
        }
      }
      totalRecords
    }
  }
`;
